import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { GoodsFormulaDetail, GoodsFormulaHeader } from "./goods-formula-detail.model";

export class Goods extends EntityBase {
  public GoodsGroupId?: number;
  public GoodsGroupTreePath: string;
  public GoodsGroupTreeCode: string;
  public Code: string;
  public Title: string;
  public LatinTitle: string;
  public Comment: string;
  public LatinComment: string;
  public GoodsKindId: number;
  public GoodsKindCode?: number;
  public GoodsKindTitle: string;
  public UnitId: number;
  public UnitCode?: number;
  public UnitTitle: string;
  public DefaultUnitId: number;
  public DefaultUnitCode?: number;
  public DefaultUnitTitle: string;
  public Active: boolean;
  public IsGoods: boolean;
  public HasTracing: boolean;
  public IsMarketable: boolean;
  public HasTaxDuty: boolean;
  public TaxRate?: number;
  public HasExpiryDate: boolean;
  public CostSubLedgerId?: number;
  public CostSubLedgerCode?: number;
  public CostSubLedgerTitle: string;
  public DetailLedgerId?: number;
  public DetailLedgerCode?: number;
  public DetailLedgerTitle: string;
  public GoodsUnits: GoodsUnit[];
  public RemainAmount?: number;
  public UnitPrice?: number;
  public TotalPrice?: number;
  public DefaultUnitRatio: number;
  public GoodsFormulaHeaders: GoodsFormulaHeader[];
  public GoodsBarCodes: GoodsBarCode[];
  public GoodsGroupDetailLedgerId?: number;
  public GoodsGroupDetailLedgerCode?: number;
  public GoodsGroupDetailLedgerTitle: string;
  public Attribute: string;
  public UsedInInvDailyVoucher?: Boolean;

  public GoodsRahkaranRelationId?: number;
}

export class GoodsUnit extends EntityBase {
  public GoodsId: number;
  public IsDefault: boolean;
  public Ratio: number;
  public UnitCode?: number;
  public UnitId: number;
  public UnitTitle: string;
}

export class GoodsBarCode extends EntityBase {
  public GoodsId: number;
  public BarCode: string;
  public BarCodeTitle: string;
}
